<section class="sk-cms-nav {{basic.style.type}}"
    {{if style.background.styleType != 'default'}}
        {{if style.background.backgroundType == 'color'}}
            style="background-color:{{style.background.color}}"
        {{/if}}
        {{if style.background.backgroundType == 'img'}}
            style="background-image:url('{{style.background.imgUrl}}')"
        {{/if}}
    {{/if}}
>
    <div class="nav-main">
        <div class="nav-logo">
            {{if style.isShowLogo == '1' && content.logo}}
            <img src="{{content.logo}}" alt="logo">
            {{/if}}
        </div>
        <nav class="nav-list">
            <ul class="nav-ul">
                {{each content.items}}
                <% include('../common/navitem.art', {value: $value, style: style.menu1, style2: style.menu2, isDesign: isDesign}) %>
                {{/each}}
            </ul>
        </nav>
    </div>
</section>
